import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedDirectivesSrcErrorModule } from '@fantaz/shared/directives/src-error';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { TournamentControlsModule } from '@fantaz/tournaments-v2/ui/tournament-controls';
import { TournamentsUiCountdownModule } from '@fantaz/tournaments/ui/countdown';
import { TournamentsUiDialogVideoModule } from '@fantaz/tournaments/ui/dialog-video';
import { BannerComponent } from './banner.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    TournamentControlsModule,
    SharedDirectivesSrcErrorModule,
    SharedPipesDateModule,
    MaterialModule,
    TournamentsUiCountdownModule,
    TournamentsUiDialogVideoModule,
  ],
  declarations: [BannerComponent],
  exports: [BannerComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TournamentBannerModule {}
